import {fetchAssociateScanMetrics} from "../network/AssociateNetworkAPI";

export const AssociateScanReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_DATA":
            const {dispatcher} = action.data;
            fetchAssociateScanMetrics(dispatcher)
            return state
        case "RECEIVE_DATA":
            const scanData = action.data.associateScanMetricResponseMap || {};

            if (scanData["15m"] && Object.keys(scanData["15m"]).length > 0) {
                scanData["cumulative"] = {};
                Object.keys(scanData["15m"]).forEach(email => {
                    const data15m = scanData["15m"][email];
                    if (data15m && Array.isArray(data15m)) {
                        let cumulativeSum = 0;
                        scanData["cumulative"][email] = data15m.map(item => {
                            cumulativeSum += item.metricValue || 0;
                            return {
                                timeStampVal: item.timeStampVal,
                                metricValue: cumulativeSum
                            };
                        });
                    }
                });
            }

            const firstGranularity = Object.keys(scanData)[0];
            const associateList = firstGranularity && scanData[firstGranularity] ?
                Object.keys(scanData[firstGranularity])
                    .sort()
                    .map(email => ({
                        key: email,
                        name: email.replace('@amazon.com', '')
                    })) : [];

            const isFirstLoad = state.associateList.length === 0;
            const newAssociateKeys = associateList.map(associate => associate.key);
            const existingSelection = state.chartData.selectedAssociates.filter(key =>
                newAssociateKeys.includes(key)
            );

            return {
                ...state,
                scanMetrics: scanData,
                associateList: associateList,
                chartData: {
                    ...state.chartData,
                    selectedAssociates: isFirstLoad ? newAssociateKeys : existingSelection
                }
            }
        case "SET_SELECTED_ASSOCIATES":
            return {
                ...state,
                chartData: {
                    ...state.chartData,
                    selectedAssociates: action.data.selectedAssociates,
                },
            };
        case "SET_GRANULARITY":
            return {
                ...state,
                chartData: {
                    ...state.chartData,
                    granularity: action.data.granularity,
                },
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/associate/reducers/AssociateScanReducer.js